import { clamp, getDevicePixelRatio, isWebPSupported } from '@djs';
import { config } from '../../config';

let isWebPSupport = false;
isWebPSupported((isSupport) => (isWebPSupport = isSupport));

const realDpr = getDevicePixelRatio();
const dpr = clamp(Math.round(realDpr), 1, 3);
const suffix = dpr === 1 ? '' : `@${dpr}x`;

interface GetImageSourceOptions {
  format: 'svg' | 'png' | 'jpeg';
  webp?: boolean;
  ratio?: boolean;
}

function getAssetSource(path: string, name: string, format: string): string {
  const staticAssetsUrl = config.staticAssetsUrl;

  return `${staticAssetsUrl}${path}/${name}.${format}`;
}

function getImageSource(path: string, name: string, options: GetImageSourceOptions): string {
  const { format, webp, ratio } = options;
  const formatSource = webp && isWebPSupport ? 'webp' : format;
  const fullName = `${name}${ratio ? suffix : ''}`;

  return getAssetSource(path, fullName, formatSource);
}

export const imageGetters = {
  crush: {
    landingBanner: () =>
      getImageSource('crush', 'landing_top_section_banner', { format: 'png', webp: true, ratio: true }),
    avatars: () => getImageSource('crush', 'avatars', { format: 'png', webp: true, ratio: true }),
    headerBgImage: (key: 'desktop_background' | 'mobile_background') =>
      getImageSource('crush/header', key, { format: 'jpeg', webp: true, ratio: true }),
    crown: () => getImageSource('crush', 'crown_title', { format: 'png', webp: true, ratio: true }),
    prize: (key: string, appearance: 'light' | 'dark') =>
      getImageSource(`crush/prizes/${appearance}`, key, { format: 'png', webp: true, ratio: true }),
  },
};
